import { render, staticRenderFns } from "./Ubah.vue?vue&type=template&id=7037d003"
import script from "./Ubah.vue?vue&type=script&lang=js"
export * from "./Ubah.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports